module.exports = __webpack_public_path__ + "fonts/sourcesanspro.681f5795.woff2";